import React from 'react';
import { useParams } from 'react-router-dom';
import PropertyDashboard from '../../../../components/PropertyDashboard/PropertyDashboard';
import PostLoginHeader from '../../../../components/PostLoginHeader/PostLogin';

const PropertyDetailsPage: React.FC = () => {
    const { id } = useParams<{ id: string }>();

    if (!id) {
        return <div>Property ID not found.</div>;
    }

    return (
        <div className="bg-gray-50 min-h-screen">
            <PostLoginHeader />
            <main className="container mx-auto py-8 px-4">
                <PropertyDashboard propertyId={id} />
            </main>
        </div>
    );
};

export default PropertyDetailsPage;
